import { Pill } from '@scoir/pills'
import { SchoolType } from '../types'

export default function SchoolTypePill({ schoolType }: { schoolType: SchoolType }) {
  if (schoolType === 'public') {
    return <Pill color="success">Public</Pill>
  }

  return <Pill color="success">Private</Pill>
}
